import { useContext } from 'react';
import { LogContext } from '../contexts/LogContext';

  
// Create a hook to access the context
export const useLog = () => useContext(LogContext);